import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { User } from '@recruitee/account-types';
import { TranslatePipe } from '@recruitee/i18n';
import { IconComponent, RtTooltip, UserListTooltipComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-anonymous-revealed-for',
  template: `
    <div
      rtTooltip
      [rtTooltipTemplate]="tooltipTpl"
      [rtTooltipMaxWidth]="269"
      rtTooltipPosition="below"
      (click)="$event.stopImmediatePropagation()"
      layout
      layout-align-items-center
      padding-lr-small-x
      data-cy="anonymous-revealed-for"
    >
      <rt-icon name="info-outline" margin-right-small-xx></rt-icon>
      <span class="pointer-events-none" text-weight-semi-bold>
        {{
          'app.candidate.anonymization.team_members_revealed' | translate: { count: users().length }
        }}
      </span>
    </div>
    <ng-template #tooltipTpl>
      <rt-user-list-tooltip [users]="users()">
        <strong heading>
          {{ 'app.candidate.anonymization.who_seen_hidden_details' | translate }}
        </strong>
      </rt-user-list-tooltip>
    </ng-template>
  `,
  styleUrl: 'anonymous-revealed-for.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslatePipe, RtTooltip, UserListTooltipComponent],
})
export class AnonymousRevealedForComponent {
  public readonly users = input.required<User[]>();
}
